import React from "react";

import ReportSubsection, {
  ReportSubsectionProps,
} from "@app/analytics/components/reports/ReportSubsection";
import useEditStore from "@app/analytics/MeetingReport/stores/edits";
import { DisabledOverlay } from "@app/analytics/MeetingReport/styles";

interface EditableReportSubSectionProps extends ReportSubsectionProps {
  disabledTooltip: string;
}

/** Simple wrapper that applies an overlay over a section when another section
 * is being edited. */
const EditableReportSubSection = ({
  disabledTooltip,
  ...props
}: EditableReportSubSectionProps) => {
  const isSectionDisabled = useEditStore(
    (state) => state.editingSection != null && state.editingSection !== props.id
  );

  return (
    <ReportSubsection
      {...props}
      overlay={
        isSectionDisabled ? <DisabledOverlay tooltip={disabledTooltip} /> : null
      }
    />
  );
};

export default EditableReportSubSection;
